function computeHeight(ref) {
    const el = ref.current;
    if (!el) {
        return;
    }

    const prevDisplay = el.style.display || '';
    el.style.display = 'block';
    const height = el.offsetHeight;
    el.style.display = prevDisplay;
    return height;
}

export {
    computeHeight,
};

export default {
    computeHeight,
};
